/**
 * Directiva utilizada para ver y añadir comentarios a las tareas
 */
ComentariosDirectiva.$inject = [];

export default function ComentariosDirectiva() {
    return {
        restrict: 'AE',
        scope: {
            'modelId': '=',
            'model': '@',
            'canAdd': '=',
        },
        template: require('./comentarios.html'),
        controller: 'ComentariosCtrl',
        controllerAs: 'vm',
        bindToController: true
    }
}